// POS printer idarəetmə gateway-i.
//
// Printer-lərin cloud-da QARŞILIĞI YOXDUR — bu, sırf pos_local (offline POS)
// konseptidir. Ona görə bu modul axios interceptor (routes.ts) ilə cloud path-ı
// imitasiya ETMİR; birbaşa `posRequest` ilə pos_local /v1/printers endpoint-lərinə
// gedir. UI (pages/PosPrinters.tsx) bu funksiyaları birbaşa çağırır.
//
// Yazma əməliyyatları (create/update/delete/test) pos_local-da `manager+` rol
// tələb edir → rol yoxdursa backend 403 INSUFFICIENT_ROLE qaytarır.

import { posRequest, PosResponse } from './posClient';

// ── tiplər ───────────────────────────────────────────────────────────────────

export type PrinterStation = 'kitchen' | 'bar' | 'cashier' | 'bill' | 'other';
export type PrinterConnection = 'tcp' | 'usb' | 'file';

export interface PosPrinter {
  id: string;
  name: string;
  station: PrinterStation;
  connection: PrinterConnection;
  address: string;
  paperWidth: number; // simvol genişliyi (adətən 48 və ya 32)
  codepage: string;
  categoriesJson: string; // JSON array string; boş "[]" = bütün kateqoriyalar
  enabled: boolean;
  /**
   * Cloud-dan (Rezmo Admin) sync olunubsa revizyon nömrəsi, POS-da əl ilə
   * yaradılıbsa `null`. Sync olunan printer POS-dan redaktə edilmir.
   */
  cloudRevision: number | null;
}

// ── əməliyyatlar ─────────────────────────────────────────────────────────────

/** GET /v1/printers — konfiqurasiya olunmuş printer siyahısı. */
export function listPrinters(): Promise<PosResponse<PosPrinter[]>> {
  return posRequest<PosPrinter[]>({ method: 'GET', path: '/v1/printers' });
}

// Printer YARATMA/REDAKTƏ POS-da YOXDUR — Rezmo Admin panelində edilir
// (Restoran İdarəetməsi → Printerlər) və catalog stream-i ilə bura sync olunur.
// Buradan yazsaydıq növbəti sync dəyişikliyi üstündən yazardı: iki mənbə problemi.

/** DELETE /v1/printers/:id — yalnız YERLİ (sync olunmamış) qalıqları təmizləmək üçün. */
export function deletePrinter(id: string): Promise<PosResponse<unknown>> {
  return posRequest({
    method: 'DELETE',
    path: `/v1/printers/${encodeURIComponent(id)}`,
  });
}

/** POST /v1/printers/:id/test (manager+) — test səhifəsi çap et. */
export function testPrinter(id: string): Promise<PosResponse<unknown>> {
  return posRequest({
    method: 'POST',
    path: `/v1/printers/${encodeURIComponent(id)}/test`,
  });
}

// ── çap işləri (fiziki printer olmadan yoxlamaq üçün) ────────────────────────

export interface PosPrintJob {
  id: number;
  printerId: string;
  orderId: string | null;
  kind: 'kot' | 'receipt' | 'reprint_kot' | 'reprint_receipt' | 'test';
  status: 'pending' | 'sending' | 'sent' | 'failed' | 'dead';
  attempts: number;
  lastError: string | null;
  createdAt: number;
  sentAt: number | null;
  payloadBytes: number;
}

export interface PosPrintJobPreview {
  id: number;
  kind: PosPrintJob['kind'];
  status: PosPrintJob['status'];
  printerId: string;
  orderId: string | null;
  createdAt: number;
  lastError: string | null;
  /** ESC/POS baytlarından təmizlənmiş oxunaqlı mətn. */
  text: string;
}

/** GET /v1/print-jobs — son çap işləri. */
export function listPrintJobs(limit = 20): Promise<PosResponse<PosPrintJob[]>> {
  return posRequest<PosPrintJob[]>({
    method: 'GET',
    path: `/v1/print-jobs?limit=${limit}`,
  });
}

/**
 * GET /v1/print-jobs/:id/preview — fişin mətn önizləməsi.
 * Çek aparatı qoşulu olmasa da nəyin çap olunacağını görmək üçün.
 */
export function getPrintJobPreview(
  id: number,
): Promise<PosResponse<PosPrintJobPreview>> {
  return posRequest<PosPrintJobPreview>({
    method: 'GET',
    path: `/v1/print-jobs/${id}/preview`,
  });
}
